module.exports = __webpack_public_path__ + "assets/img/5.04f35f1a.png";